import { PromotionOffer, PromotionType } from 'core/constants';
import { DiscountPromoScope, PromoStatus } from 'my-account/constants';
import { ModelBase } from 'store/model-base';
import { PromoStatusAudit } from './promo-status-audit';

export class DiscountPromotion extends ModelBase {
    public static storeName: string = 'discountPromotion';

    public orderId: string;
    public type: PromotionType;
    public scope: DiscountPromoScope;
    public promoGuid: string;
    public promoBOID: string;
    public promoName: string;
    public promoStatusAudit: PromoStatusAudit[];
    public amount: number;
    public percentValue: number;
    public subsidyRemaining: string;
    public subsidyAmountRemaining: string;
    public subsidyType: string;
    public promotionTerm: number;
    public lineId?: string;
    public qualifyingLineIds?: string[];
    public subsidyStatus: string;
    public state: PromoStatus;
    public isRestore: boolean;
    public billerInfo: PromoBillerInfo;

    public isServiceLinePromo: boolean;
    public isServiceAccountPromo: boolean;
    public isPromoStateEligible: boolean;
    public isLinePromoEligible: boolean;
    public isAccountPromoEligible: boolean;
    public isLinePromoBYOEligible: boolean;
    public isAccountPromoUNLBOGOEligible: boolean;
    public isLinePromoUNLFREEEligible: boolean;
    public isLinePromoUNLHL25Eligible: boolean;
    public isTradeInDDAPromoEligible: boolean;
    public isExtendedPromoDollarEligible: boolean;
    public isEligiblePromo: boolean;
    public isPlans8UnlFreeLinePromo: boolean;
    public isPlans8UnlFreeLineAnytimePromo: boolean;
    public isPlans8FreeLinePromo: boolean;

    public static create<T extends ModelBase>(toReturn: ApiResponse): T {
        toReturn.isServiceLinePromo = toReturn.type === PromotionType.SERVICE_PROMO_LINE || toReturn.type === PromotionType.SERVICE_PROMO_LINE_DISCOUNT;
        toReturn.isServiceAccountPromo = toReturn.type === PromotionType.SERVICE_PROMO_ACCOUNT || toReturn.type === PromotionType.SERVICE_PROMO_ACCOUNT_DISCOUNT;
        toReturn.isPromoStateEligible = (toReturn.state === PromoStatus.NEW) || (toReturn.state === PromoStatus.ACTIVE);
        toReturn.isPromoStateActive = toReturn.state === PromoStatus.ACTIVE;
        toReturn.isEligiblePromo = (toReturn.isServiceLinePromo || toReturn.isServiceAccountPromo) && toReturn.isPromoStateEligible;
        toReturn.isLinePromoEligible = toReturn.isServiceLinePromo && toReturn.isPromoStateEligible;
        toReturn.isAccountPromoEligible = toReturn.isServiceAccountPromo && toReturn.isPromoStateEligible;
        toReturn.isLinePromoBYOEligible = toReturn.isLinePromoEligible && (toReturn.promoBOID === PromotionOffer.BYOD_LL_SERP);
        toReturn.isAccountPromoUNLBOGOEligible = toReturn.isAccountPromoEligible && (toReturn.promoBOID === PromotionOffer.UNLBOGO_AL_SERP);
        toReturn.isLinePromoUNLFREEEligible = toReturn.isLinePromoEligible && (toReturn.promoBOID === PromotionOffer.UNLFREE_LL_SERP);
        toReturn.isLinePromoUNLHL25Eligible = toReturn.isLinePromoEligible && (toReturn.promoBOID === PromotionOffer.UNLHL25_LL_SERP);
        toReturn.isTradeInDDAPromoEligible =  toReturn.isPromoStateEligible && (toReturn.type === PromotionType.TRADEIN_PROMO_DDA);
        toReturn.isExtendedPromoDollarEligible =  toReturn.isPromoStateActive && ((toReturn.type === PromotionType.EXTENDED_PROMO_DOLLAR_DDA) || (toReturn.type === PromotionType.EXTENDED_PROMO_UPGRADE_DDA));
        toReturn.isPlans8UnlFreeLinePromo = toReturn.isEligiblePromo && (toReturn.promoBOID === PromotionOffer.PLAN8_UNLFREE_PROMO);
        toReturn.isPlans8UnlFreeLineAnytimePromo = toReturn.isEligiblePromo && (toReturn.promoBOID === PromotionOffer.PLAN8_UNLFREE_ANYTIME_PROMO);
        toReturn.isPlans8FreeLinePromo = toReturn.isEligiblePromo && (toReturn.promoBOID === PromotionOffer.PLAN8_FREELINE_PROMO);


        return super.create<T>(toReturn);
    }
}
